// extracted by mini-css-extract-plugin
export default {"root":"DraggableList_root__hC7PZ","list":"DraggableList_list__rotqQ"};